var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#DCDCDC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 50,
    height: 45,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 54.6668C60.1668 56.6835 58.526 58.3335 56.5002 58.3335H41.8335H34.5002H23.5002C21.4751 58.3335 19.8335 56.6835 19.8335 54.6668V29.0002C19.8335 26.9835 21.4751 25.3335 23.5002 25.3335H34.5002H41.8335H49.1668H56.5002C58.526 25.3335 60.1668 26.9835 60.1668 29.0002V36.3335V54.6668Z",
    fill: "#95A5A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8335 52.8333C19.8335 54.85 21.4751 56.5 23.5002 56.5H38.1668H45.5002H56.5002C58.526 56.5 60.1668 54.85 60.1668 52.8333V27.1667C60.1668 25.15 58.526 23.5 56.5002 23.5H45.5002H38.1668H30.8335H23.5002C21.4751 23.5 19.8335 25.15 19.8335 27.1667V34.5V52.8333Z",
    fill: "#BDC3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5 27.1665H23.5V52.8332H56.5V27.1665Z",
    fill: "#F39C12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4791 33.8125L29.5151 52.8333H56.5V41.8333L48.4791 33.8125Z",
    fill: "#E67E22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1668 36.3332C38.1668 38.035 37.4908 39.6671 36.2874 40.8704C35.0841 42.0738 33.452 42.7498 31.7502 42.7498C30.0484 42.7498 28.4163 42.0738 27.2129 40.8704C26.0095 39.6671 25.3335 38.035 25.3335 36.3332C25.3335 34.6314 26.0095 32.9993 27.2129 31.7959C28.4163 30.5925 30.0484 29.9165 31.7502 29.9165C33.452 29.9165 35.0841 30.5925 36.2874 31.7959C37.4908 32.9993 38.1668 34.6314 38.1668 36.3332Z",
    fill: "#F1C40F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8386 38.3389L23.5 47.6779V52.8332H47.3333L32.8386 38.3389Z",
    fill: "#D35400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e856385b0d61de0638cf9c81a92e4363.svg";
export { ForwardRef as ReactComponent };